import React from 'react';
import { TailSpin } from 'react-loader-spinner';

const SpinnerLoader = () => {
    return (
        <div className="d-flex">
            <TailSpin color="#5f5f5f" height={20} width={20} />
            <div className="ml-3">CHARGEMENT</div>
        </div>
    );
};

export default SpinnerLoader;
